<template>
  <div class="user">
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="手机号">
          <el-input placeholder="请输入手机号" v-model="formInline.search">
            <el-button slot="append" icon="el-icon-search" @click="getData">查询</el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table
            size="small"
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column prop="mobile" label="手机号"></el-table-column>
            <el-table-column prop="model" label="车型"></el-table-column>
            <el-table-column prop="duration" label="年限"></el-table-column>
            <el-table-column prop="address" label="地点"></el-table-column>
            <el-form-item label="素材图片：" prop="form.image">
              <div class="draggable-list">
                <draggable class="wrapper" v-model="form.images">
                  <transition-group>
                    <div v-for="(item, index) in form.images" :key="item.file_path">
                      <div class="item">
                        <img v-img-url="item.file_path" alt="file_path"/>
                      </div>
                    </div>
                  </transition-group>
                </draggable>
                <div class="item img-select" @click="openProductUpload('album')">
                  <i class="el-icon-plus"></i>
                </div>
              </div>
            </el-form-item>
            <el-table-column prop="price" label="薪资待遇"></el-table-column>
            <el-table-column label="图片">
              <template slot-scope="scope">
                <img
                  v-if="scope.row.images && scope.row.images.length > 0"
                  :src="scope.row.images"
                  alt="图片"
                  style="width: 100px; height: auto;"
                />
              </template>
            </el-table-column>
            <el-table-column prop="nickName" label="添加人"></el-table-column>
            <el-table-column prop="create_time" label="添加时间"></el-table-column>
            <el-table-column label="审核状态">
              <template slot-scope="scope">
                <div v-if="scope.row.status == 0">未审核</div>
                <div v-if="scope.row.status == 1">审核通过</div>
                <div v-if="scope.row.status == 2">审核未通过</div>
              </template>
            </el-table-column>

            <el-table-column
              prop="reject_val"
              label="审核不通过原因"
            ></el-table-column>

            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status == 0"
                  @click="passClick(scope.row)"
                  type="text"
                  size="small"
                  >审核</el-button
                >
                <el-button
                  v-if="scope.row.status == 0"
                  @click="nopassClick(scope.row)"
                  type="text"
                  size="small"
                  >审核不通过</el-button
                >
                <el-button
                  @click="deleteClick(scope.row)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

   

    <el-dialog
      style="text-align: center"
      title="设置标题"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
    </el-dialog>
  </div>
</template>

<script>
import PickCotton from "@/api/pick_cotton.js";

export default {
  components: {
  
  },
  inject: ["reload"],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search: ""
      },
      pick_cotton: "",
      dialogVisible: false
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    passClick(item) {
      //通过审核
      var self = this;
      var Params = {
        pick_cotton_id: item.pick_cotton_id,
        status: 1
      };
      PickCotton.passCanel(Params, true)
        .then(data => {
          console.log(data);
          if (data.code == 1) {
            self.$message({
              type: "success",
              message: "审核成功"
            });
            self.getTableList();
            return false;
          }
        })
        .catch(error => {});
    },
    async nopassClick(item) {
      //不通过审核
      var self = this;
      const reject_val = await this.promptInput(
        "请输入不通过的原图",
        "请输入2-4个汉字"
      );

      var Params = {
        pick_cotton: item.pick_cotton,
        status: 2,
        reject_val: reject_val
      };
      PickCotton.passCanel(Params, true)
        .then(data => {
          if (data.code == 1) {
            self.$message({
              type: "success",
              message: "审核成功"
            });
            self.getTableList();
            return false;
          }
        })
        .catch(error => {});
    },
    async promptInput(message, validation) {
      try {
        const { value } = await this.$prompt(message, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputErrorMessage: validation
        });
        return value.trim();
      } catch (e) {
        this.$message({
          type: "info",
          message: "取消输入"
        });
      }
    },
    dialogFormVisible() {
      this.dialogVisible = false;
    },
    setting(e) {
      //标题设置
      // this.categorya_id = e
      this.dialogVisible = true;
    },
   
    getData() {
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      PickCotton.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          PickCotton.del(
            {
              pick_cotton: row.pick_cotton
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.getTableList();
              } else {
                self.$message.error("错了哦，这是一条错误消息");
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/pick_cotton/index/index.vue